import { instance } from "apis/interceptor";

type ResponseType<T> = {
  success: boolean;
  message?: string;
  statusCode?: number;
  data?: T;
};

//FEAT: (new) 로그아웃
export const logout = async (): Promise<ResponseType<boolean>> => {
  try {
    const res = await instance.post("/auth/logout");

    return { success: true, data: res.data };
  } catch (error: any) {
    return { success: false, message: "오류가 발생했습니다. 다시 시도해 주세요." };
  }
};
